import React from 'react';
import Input from '@strata/tempo/lib/input';
import Form from '@strata/tempo/lib/form';
import Button from '@strata/tempo/lib/button';
import { IOrgPinPrompt } from './data/IEmail';
import { EmailFormService } from './data/EmailFormService';

export interface IOrgPinOnlyFormProps {
  email: string;
  onOrgPinOnlyFormNext: (orgPinResponse: IOrgPinPrompt) => void;
  orgPin: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IOrgPinFormValues {
  [name: string]: string;
}

const OrgPinOnlyForm: React.FC<IOrgPinOnlyFormProps> = ({ email, orgPin, onOrgPinOnlyFormNext, setLoading }) => {
  const [form] = Form.useForm<IOrgPinFormValues>();

  const onFormFinish = async (values: IOrgPinFormValues) => {
    setLoading(true);
    try {
      const response = await EmailFormService.postOrgpin(email, values.orgPin);
      if (response.ssoRedirectUrl) {
        setLoading(false);
        window.location.href = response.ssoRedirectUrl;
      }
    } catch (error) {
      onOrgPinOnlyFormNext(error as IOrgPinPrompt);
    }
  };

  return (
    <Form layout='vertical' form={form} onFinish={onFormFinish}>
      <Form.Item label='Org PIN' name='orgPin' initialValue={orgPin} rules={[{ required: true, message: 'Enter an Org PIN' }]}>
        <Input type='tel' />
      </Form.Item>
      <Form.Item name='login'>
        <Button block type='primary' htmlType='submit' disabled={orgPin === ''}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default OrgPinOnlyForm;
